import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import { Container } from "reactstrap";

import { getChannel } from "../../store/actions/channels";
import { getTags } from "../../store/actions/tags";
import addChannel from "../../requests/addChannel"

import ChannelForm from "../../components/Channels/ChannelForm";


const Dashboard = props => {
  const [id, setId] = useState(props.match.params.id);
  useEffect(() => {
    setId(props.match.params.id);
    if (
      (id && !props.channels[id]) ||
      (props.channels[id] && props.channels[id].type === 'PROMOTED_CHANNEL' && props.channels[id].tracks && Object.keys(props.channels[id].tracks[0]).length<3) ||
      (props.channels[id] && props.channels[id].type === 'AUTOMATIC_CHANNEL' && !props.channels[id].sortType)
    ) {
      props.getChannel(id);
    }
    if (!props.tags.length) props.getTags();
  });
  const handleSubmit = values => {
    return new Promise((resolve, reject) => {
      const { name, englishName, displayName, country, status, description, id, search, startPoint, startPointType, djname, link, sortType } = values;
      addChannel({
        data: {
          name,
          englishName,
          displayName,
          country,
          status,
          description,
          id: id || null,
          DJName: djname,
          link,
          startPoint: search ? search[0].id : startPoint || '',
          startPointType: startPointType !== 'NO' ? startPointType : '',
          sortType: sortType.toUpperCase(),
          renewPic: values.coverFile.file ? true : false,
          renewEnglishPic: values.englishCoverFile.file ? true : false
        },
        type: values.type,
        tracks: values.tracks ?
          {
            items: values.tracks.map(track => ({ id: track.id, name: track.name }))
          }
          : undefined,
        cover: values.coverFile.file,
        englishCover: values.englishCoverFile.file,
        tag: {
          items: values.tags || []
        },
        excludeTag: {
          items: values.excludeTags || []
        }
      })
        .then(response => {
          props.getChannel(id || response.data.identifier);
          resolve();
        })
        .catch(reject)
    })
  }
  return (
    <Container fluid>
      <h4 className="mb-4">{id ? 'ویرایش کانال' : 'افزودن کانال'}</h4>
      {id && props.channels[id] &&
        <ChannelForm
          data={id && props.channels[id]}
          tags={props.tags}
          onSubmit={handleSubmit}
          goBack={() => props.history.push('/channels')}
        />
      }
      {!id &&
        <ChannelForm
          tags={props.tags}
          onSubmit={handleSubmit}
          goBack={() => props.history.push('/channels')}
        />
      }
    </Container>
  )
}


export default connect(
  state => (
    {
      channels: state.channels,
      tags: state.tags
    }
  ),
  dispatch => bindActionCreators({
    getChannel,
    getTags
  }, dispatch)
)(Dashboard)